import React from 'react';

import { Flex } from '@chakra-ui/react';
import ReviewerTypeTag from 'Deer/components/common/ReviewerTypeTag';

import { Avatar } from 'uiToolkitV1/Avatar';
import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

const PeerDetailsRow = ({ employee, providerType, peerType }) => {
  const { displayName, profilePhotoSrc, designation } = employee ?? {}; // id to be used to redirect to profile page in future?

  return (
    <Flex width="100%" justifyContent="space-between">
      <Flex flexDirection="row" alignItems="center">
        <Avatar src={profilePhotoSrc} name={displayName} />
        <Flex flexDir="column" ml="8px">
          <TextBodyMedium bold>{displayName}</TextBodyMedium>
          {designation && <TextLabel>{designation}</TextLabel>}
        </Flex>
      </Flex>
      <ReviewerTypeTag peerType={peerType} providerType={providerType} />
    </Flex>
  );
};

export default PeerDetailsRow;
